import * as Types from '../../../../../../../../libs/pep-shared/src/lib/services/api-services/ods/api/ods-api.types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import * as ApolloCore from '@apollo/client/core';
export type CreateConsentMutationVariables = Types.Exact<{
  input: Types.InputCreateConsent;
}>;

export type CreateConsentMutation = { __typename?: 'Mutation'; createConsent: boolean };

export type ConsentQueryVariables = Types.Exact<{
  id: Types.Scalars['Int64'];
}>;

export type ConsentQuery = {
  __typename?: 'Query';
  consent: {
    __typename?: 'Consent';
    id: any;
    createdAt: any;
    updatedAt: any;
    studySiteID: any;
    dmSubjID: string;
    consentType: string;
    protocol: string;
    version: string;
    versionDt: any;
    fldName: string;
    fldValue: string;
    startDt: any;
    endDt?: any | null;
    currRowInd: boolean;
  };
};

export type ConsentsQueryVariables = Types.Exact<{
  queryParams: Types.InputQueryConsent;
}>;

export type ConsentsQuery = {
  __typename?: 'Query';
  consents: Array<{
    __typename?: 'Consent';
    id: any;
    createdAt: any;
    updatedAt: any;
    studySiteID: any;
    dmSubjID: string;
    consentType: string;
    protocol: string;
    version: string;
    versionDt: any;
    fldName: string;
    fldValue: string;
    startDt: any;
    endDt?: any | null;
    currRowInd: boolean;
  } | null>;
};

export type CreatePatientDmMutationVariables = Types.Exact<{
  input: Types.InputCreatePatientDm;
}>;

export type CreatePatientDmMutation = {
  __typename?: 'Mutation';
  createPatientDM: {
    __typename?: 'PatientDM';
    id: any;
    createdAt: any;
    updatedAt: any;
    studySiteID: any;
    dmSubjID: string;
    firstName?: string | null;
    lastName?: string | null;
    dmSex?: string | null;
    dob?: any | null;
    email?: string | null;
    zipCode?: string | null;
    ssn?: string | null;
    race?: string | null;
    raceOther?: string | null;
    employmentStat?: string | null;
    maritalStat?: string | null;
    birthYr?: any | null;
    ageDiag?: any | null;
    yearDiag?: any | null;
    timepoint?: string | null;
  };
};

export type UpdatePatientDmMutationVariables = Types.Exact<{
  input: Types.InputUpdatePatientDm;
}>;

export type UpdatePatientDmMutation = {
  __typename?: 'Mutation';
  updatePatientDM: {
    __typename?: 'PatientDM';
    id: any;
    createdAt: any;
    updatedAt: any;
    studySiteID: any;
    dmSubjID: string;
    firstName?: string | null;
    lastName?: string | null;
    dmSex?: string | null;
    dob?: any | null;
    email?: string | null;
    zipCode?: string | null;
    ssn?: string | null;
    race?: string | null;
    raceOther?: string | null;
    employmentStat?: string | null;
    maritalStat?: string | null;
    birthYr?: any | null;
    ageDiag?: any | null;
    yearDiag?: any | null;
    timepoint?: string | null;
  };
};

export type PatientDmQueryVariables = Types.Exact<{
  id: Types.Scalars['Int64'];
}>;

export type PatientDmQuery = {
  __typename?: 'Query';
  patientDM: {
    __typename?: 'PatientDM';
    id: any;
    createdAt: any;
    updatedAt: any;
    studySiteID: any;
    dmSubjID: string;
    firstName?: string | null;
    lastName?: string | null;
    dmSex?: string | null;
    dob?: any | null;
    email?: string | null;
    zipCode?: string | null;
    ssn?: string | null;
    race?: string | null;
    raceOther?: string | null;
    employmentStat?: string | null;
    maritalStat?: string | null;
    birthYr?: any | null;
    ageDiag?: any | null;
    yearDiag?: any | null;
    timepoint?: string | null;
  };
};

export type PatientDMsQueryVariables = Types.Exact<{
  queryParams: Types.InputQueryPatientDm;
}>;

export type PatientDMsQuery = {
  __typename?: 'Query';
  patientDMs: Array<{
    __typename?: 'PatientDM';
    id: any;
    createdAt: any;
    updatedAt: any;
    studySiteID: any;
    dmSubjID: string;
    firstName?: string | null;
    lastName?: string | null;
    dmSex?: string | null;
    dob?: any | null;
    email?: string | null;
    zipCode?: string | null;
    ssn?: string | null;
    race?: string | null;
    raceOther?: string | null;
    employmentStat?: string | null;
    maritalStat?: string | null;
    birthYr?: any | null;
    ageDiag?: any | null;
    yearDiag?: any | null;
    timepoint?: string | null;
  } | null>;
};

export type CreatePatientStudyMutationVariables = Types.Exact<{
  input: Types.InputCreatePatientStudy;
}>;

export type CreatePatientStudyMutation = { __typename?: 'Mutation'; createPatientStudy: boolean };

export const CreateConsentDocument = /*#__PURE__*/ gql`
  mutation createConsent($input: InputCreateConsent!) {
    createConsent(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateConsentGQL extends Apollo.Mutation<
  CreateConsentMutation,
  CreateConsentMutationVariables
> {
  document = CreateConsentDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ConsentDocument = /*#__PURE__*/ gql`
  query Consent($id: Int64!) {
    consent(id: $id) {
      id
      createdAt
      updatedAt
      studySiteID
      dmSubjID
      consentType
      protocol
      version
      versionDt
      fldName
      fldValue
      startDt
      endDt
      currRowInd
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ConsentGQL extends Apollo.Query<ConsentQuery, ConsentQueryVariables> {
  document = ConsentDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ConsentsDocument = /*#__PURE__*/ gql`
  query Consents($queryParams: InputQueryConsent!) {
    consents(queryParams: $queryParams) {
      id
      createdAt
      updatedAt
      studySiteID
      dmSubjID
      consentType
      protocol
      version
      versionDt
      fldName
      fldValue
      startDt
      endDt
      currRowInd
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ConsentsGQL extends Apollo.Query<ConsentsQuery, ConsentsQueryVariables> {
  document = ConsentsDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePatientDmDocument = /*#__PURE__*/ gql`
  mutation createPatientDM($input: InputCreatePatientDM!) {
    createPatientDM(input: $input) {
      id
      createdAt
      updatedAt
      studySiteID
      dmSubjID
      firstName
      lastName
      dmSex
      dob
      email
      zipCode
      ssn
      race
      raceOther
      employmentStat
      maritalStat
      birthYr
      ageDiag
      yearDiag
      timepoint
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreatePatientDmGQL extends Apollo.Mutation<
  CreatePatientDmMutation,
  CreatePatientDmMutationVariables
> {
  document = CreatePatientDmDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePatientDmDocument = /*#__PURE__*/ gql`
  mutation updatePatientDM($input: InputUpdatePatientDM!) {
    updatePatientDM(input: $input) {
      id
      createdAt
      updatedAt
      studySiteID
      dmSubjID
      firstName
      lastName
      dmSex
      dob
      email
      zipCode
      ssn
      race
      raceOther
      employmentStat
      maritalStat
      birthYr
      ageDiag
      yearDiag
      timepoint
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdatePatientDmGQL extends Apollo.Mutation<
  UpdatePatientDmMutation,
  UpdatePatientDmMutationVariables
> {
  document = UpdatePatientDmDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientDmDocument = /*#__PURE__*/ gql`
  query patientDM($id: Int64!) {
    patientDM(id: $id) {
      id
      createdAt
      updatedAt
      studySiteID
      dmSubjID
      firstName
      lastName
      dmSex
      dob
      email
      zipCode
      ssn
      race
      raceOther
      employmentStat
      maritalStat
      birthYr
      ageDiag
      yearDiag
      timepoint
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientDmGQL extends Apollo.Query<PatientDmQuery, PatientDmQueryVariables> {
  document = PatientDmDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientDMsDocument = /*#__PURE__*/ gql`
  query patientDMs($queryParams: InputQueryPatientDM!) {
    patientDMs(queryParams: $queryParams) {
      id
      createdAt
      updatedAt
      studySiteID
      dmSubjID
      firstName
      lastName
      dmSex
      dob
      email
      zipCode
      ssn
      race
      raceOther
      employmentStat
      maritalStat
      birthYr
      ageDiag
      yearDiag
      timepoint
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientDMsGQL extends Apollo.Query<PatientDMsQuery, PatientDMsQueryVariables> {
  document = PatientDMsDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePatientStudyDocument = /*#__PURE__*/ gql`
  mutation createPatientStudy($input: InputCreatePatientStudy!) {
    createPatientStudy(input: $input)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreatePatientStudyGQL extends Apollo.Mutation<
  CreatePatientStudyMutation,
  CreatePatientStudyMutationVariables
> {
  document = CreatePatientStudyDocument;
  client = 'ods';
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

interface WatchQueryOptionsAlone<V>
  extends Omit<ApolloCore.WatchQueryOptions<V>, 'query' | 'variables'> {}

interface QueryOptionsAlone<V> extends Omit<ApolloCore.QueryOptions<V>, 'query' | 'variables'> {}

interface MutationOptionsAlone<T, V>
  extends Omit<ApolloCore.MutationOptions<T, V>, 'mutation' | 'variables'> {}

@Injectable({ providedIn: 'root' })
export class OdsApiService {
  constructor(
    private createConsentGql: CreateConsentGQL,
    private consentGql: ConsentGQL,
    private consentsGql: ConsentsGQL,
    private createPatientDmGql: CreatePatientDmGQL,
    private updatePatientDmGql: UpdatePatientDmGQL,
    private patientDmGql: PatientDmGQL,
    private patientDMsGql: PatientDMsGQL,
    private createPatientStudyGql: CreatePatientStudyGQL
  ) {}

  createConsent(
    variables: CreateConsentMutationVariables,
    options?: MutationOptionsAlone<CreateConsentMutation, CreateConsentMutationVariables>
  ) {
    return this.createConsentGql.mutate(variables, options);
  }

  consent(variables: ConsentQueryVariables, options?: QueryOptionsAlone<ConsentQueryVariables>) {
    return this.consentGql.fetch(variables, options);
  }

  consentWatch(
    variables: ConsentQueryVariables,
    options?: WatchQueryOptionsAlone<ConsentQueryVariables>
  ) {
    return this.consentGql.watch(variables, options);
  }

  consents(variables: ConsentsQueryVariables, options?: QueryOptionsAlone<ConsentsQueryVariables>) {
    return this.consentsGql.fetch(variables, options);
  }

  consentsWatch(
    variables: ConsentsQueryVariables,
    options?: WatchQueryOptionsAlone<ConsentsQueryVariables>
  ) {
    return this.consentsGql.watch(variables, options);
  }

  createPatientDm(
    variables: CreatePatientDmMutationVariables,
    options?: MutationOptionsAlone<CreatePatientDmMutation, CreatePatientDmMutationVariables>
  ) {
    return this.createPatientDmGql.mutate(variables, options);
  }

  updatePatientDm(
    variables: UpdatePatientDmMutationVariables,
    options?: MutationOptionsAlone<UpdatePatientDmMutation, UpdatePatientDmMutationVariables>
  ) {
    return this.updatePatientDmGql.mutate(variables, options);
  }

  patientDm(
    variables: PatientDmQueryVariables,
    options?: QueryOptionsAlone<PatientDmQueryVariables>
  ) {
    return this.patientDmGql.fetch(variables, options);
  }

  patientDmWatch(
    variables: PatientDmQueryVariables,
    options?: WatchQueryOptionsAlone<PatientDmQueryVariables>
  ) {
    return this.patientDmGql.watch(variables, options);
  }

  patientDMs(
    variables: PatientDMsQueryVariables,
    options?: QueryOptionsAlone<PatientDMsQueryVariables>
  ) {
    return this.patientDMsGql.fetch(variables, options);
  }

  patientDMsWatch(
    variables: PatientDMsQueryVariables,
    options?: WatchQueryOptionsAlone<PatientDMsQueryVariables>
  ) {
    return this.patientDMsGql.watch(variables, options);
  }

  createPatientStudy(
    variables: CreatePatientStudyMutationVariables,
    options?: MutationOptionsAlone<CreatePatientStudyMutation, CreatePatientStudyMutationVariables>
  ) {
    return this.createPatientStudyGql.mutate(variables, options);
  }
}
